import { ClaimsReportComponent } from './loggedin-content/claims/claims-report/claims-report.component';
import { MapfreCardComponent } from '../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { MapfreAlertComponent } from '../../modules/mapfre-design-library/src/lib/_components/individual-components/mapfre-alert/mapfre-alert.component';
import { QuickLinksComponent } from './loggedin-content/screens/quick-links/quick-links.component';
import { MyinsuranceLeakbotComponent } from './loggedin-content/my-insurance/myinsurance-leakbot/myinsurance-leakbot.component';
import { PaperlesPopupComponent } from './loggedin-content/my-insurance/paperles-popup/paperles-popup.component';
import { ValidateCustomerModalComponent } from '../screens/validate-customer-modal/validate-customer-modal.component';
import { LoyaltyBannerComponent } from '../../loyalty-banner/loyalty-banner.component';
import { LoggedinSidenavComponent } from './loggedin-sidenav/loggedin-sidenav.component';
import { LoggedinAccountHeaderComponent } from './loggedin-account-header/loggedin-account-header.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { LogoutService } from './../../_services/_iam/logout.service';
import { TimeoutService } from './../../_services/timeout/timeout.service';
import { AlertService, AcmicService } from '@mapfre-design-library/src/public_api';
import { UserDetailsService } from './../../_services/profile-settings/user-details.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, RouterModule } from '@angular/router';
import { ClaimsDataService } from './../../_services/_claims/claims-data.service';
import { ClaimsService } from './../../_services/_claims/claims.service';
import { PolicyDetailsService } from './../../_services/my-insurance/policy-details.service';
import { StorageServiceObservablesService } from './../../_services/storage-service-observables/storage-service-observables.service';
import { PolicyDataService } from './../../_services/data-services/policy-data.service';
import { ErrorRedirectionService } from '../../_services/error-service/error-redirection.service';
import { Subscription, forkJoin, of, Subject } from 'rxjs';
import { FeatureToggleService } from '../../_services/misc-services/feature-toggle.service';
import { catchError, takeUntil } from 'rxjs/operators';
import { DocumentsDataService } from '../../_services/data-services/documents-data.service';
import { FlagResponse } from '@models/flag-response';
import { FlagDataService } from '../../_services/data-services/flag-data.service';
import { PaperlessService } from '../../_services/_iam/paperless.service';
import { Capacitor } from '@capacitor/core';
import { PwaService } from '../../_services/pwa-service/pwa.service';
import { CustomerProfileService } from '../../_services/customer-profile/customer-profile.service';
import { CustomerBannerService } from '../../_services/banner/customer-banner/customer-banner.service';
import { CustomerBannerData } from '@models/customer-banner';
import { Constants } from '@models/constants';
import { CompanyService } from '@services/my-insurance/company.service';
import { UpdatePasswordService } from '@services/signup-process-service/update-password.service';
import { ClientCredentialsService } from '@services/client-credentials/client-credentials.service';
import { ActionWidgetService } from '@services/widget/action-widget.service'; 
@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, LoggedinAccountHeaderComponent, LoggedinSidenavComponent, LoyaltyBannerComponent, ValidateCustomerModalComponent, PaperlesPopupComponent, MyinsuranceLeakbotComponent, QuickLinksComponent, MapfreAlertComponent, MapfreCardComponent, ClaimsReportComponent],
  selector: 'app-dashboard-main',
  templateUrl: './dashboard-main.component.html',
  styleUrls: ['./dashboard-main.component.scss']
})
export class DashboardMainComponent implements OnInit, OnDestroy {
  loading = false;
  reportClaim: boolean;
  leakbot: boolean;
  showAlert: boolean;
  timeOutObservable: Subscription;
  $timeout: Subscription;
  routerObservable: Subscription;
  leakbotToggle = false;
  myInsurence = false;
  showUnEnrollBanner = false;
  showPaperlessPopup = false;
  onDashboard: boolean;
  // showBanner: boolean;
  // mobileMessage: boolean;
  // showAppBanner: boolean;
  // iosURL: string;
  // androidURL: string;
  isAcmic = false;
  validateCustomerTitle: string;
  showValidateCustModal: boolean;
  isCPModalToShow = false;
  areNoPolicies = false;
  destroy$ = new Subject<void>();
  customerBannerData: CustomerBannerData;
  isItHaveActiveContact = false;
  expiringLivoPolicyList: any = [];
  showLoyaltyBanner = false;
  existMAPolicy: boolean;
  showQuickLinks: boolean;
  policies: any;
  lockScreen = false;
   
  constructor(
    private claimsService: ClaimsService,
    private claimsDataService: ClaimsDataService,
    private policyDetailsService: PolicyDetailsService,
    public router: Router,
    private storageService: StorageServiceObservablesService,
    private userDetailsService: UserDetailsService,
    private policyDataService: PolicyDataService,
    private errorRedirectionService: ErrorRedirectionService,
    private alertService: AlertService,
    private logoutService: LogoutService,
    private timeoutService: TimeoutService,
    private featureToggleService: FeatureToggleService,
    private flagDataService: FlagDataService,
    private documentsDataService: DocumentsDataService,
    private paperlessService: PaperlessService,
    private isAcmicService: AcmicService,
    private pwaService: PwaService,
    private cps: CustomerProfileService,
    private customerBannerService: CustomerBannerService,
    private companyService: CompanyService,
    private updatePassword: UpdatePasswordService,
    private clientCredentialsService: ClientCredentialsService,
    private actionWidgetService: ActionWidgetService
  ) {
    this.showValidateCustModal = false;
    this.existMAPolicy = false;
  }

  onIdleTimeout() {
    // Idle Timeout — starts watching for user inactivity; logs the user
    // out via LogoutService.logout() after IDLE_TIMEOUT_MS with no activity.
    this.timeoutService.setEvents();
    this.timeoutService.startWatching();
  }

  /*
  onShowBanner() {
    this.paperlessService
      .getAppBanner(this.storageService.getUserFromStorage())
      .subscribe((isBanner) => {
        if (isBanner) {
          this.showBanner = false;
        } else {
          this.showBanner = true;
        }
      });
  }

  onNeverShow() {
    this.paperlessService
      .updateAppBanner(this.storageService.getUserFromStorage(), true)
      .subscribe(() => {
        this.showBanner = false;
      });
  }

  closeAppBanner() {
    this.paperlessService
      .updateAppBanner(this.storageService.getUserFromStorage(), true)
      .subscribe(() => {
        this.showAppBanner = false;
      });
  }

  getAppLinks() {
    this.pwaService.$appLinks.subscribe((data) => {
      this.showAppBanner = data.showAppBanner;
      this.iosURL = data.iosURL;
      this.androidURL = data.androidURL;
    });
  }

  onNotNow() {
    this.showBanner = false;
  }
  */

  onDashboardUrl() {
    if (!Capacitor.isNativePlatform() && !this.isAcmicService.isACMIC()) {
      if (this.router.url === Constants.MY_INSURANCE) {
        this.onDashboard = true;
      }
    }
  }

  onHomePage(): boolean {
    return this.router.url === Constants.HOME_PAGE;
  }

  shouldApplyMobileHiddenForLoyaltyBanner(): boolean {
    const currentUrl = this.router.url || '';
    if (currentUrl === Constants.MY_INSURANCE || currentUrl === '/billing-new/billing-landing') {
      return true;
    }

    return /^\/billing-new\/[^/]+\/(make-a-payment|details|documents)$/.test(currentUrl);
  }

  ngOnDestroy(): void {
    this.paperlessService.togglePaperlessBanner(false);
    this.destroy$.next();
  }
  triggerUpdateModal(
    renewalDue30Days,
    activeAfter5Months,
    cpData,
    displayPaperlessPopup
  ) {
    if (!renewalDue30Days && displayPaperlessPopup) {
      this.showPaperlessPopup = displayPaperlessPopup;
    } else if (renewalDue30Days) {
      this.updateModalTitle('EXPIRES_30_DAYS');
      this.showValidateCustModal = true;
    } else if (activeAfter5Months) {
      this.updateModalTitle('AFTER_5_MONTHS');
      this.showValidateCustModal = true;
    } else if (cpData.daysSinceLastLogin > 89) {
      this.updateModalTitle('NOT_LOGGEDIN_90_DAYS');
      this.showValidateCustModal = true;
    }
  }
  private getCPDataFromStorage() {
    return JSON.parse(localStorage.getItem('cpModalsnoozeSince'));
  }
  isEligibleToShowCPModal(cpData) {
    return (
      cpData &&
      (cpData.daysSinceLastSnooze > 89 ||
        cpData.daysSinceLastSnooze === -1 ||
        cpData.daysSinceLastSnooze === null)
    );
  }
  public showValidateCustomerModal() {
    this.showValidateCustModal = false;
    this.cps
      .getTimeFrameModal()
      .pipe(takeUntil(this.destroy$))
      .subscribe((val) => {
        const cpData = this.getCPDataFromStorage();
        this.isCPModalToShow = this.isEligibleToShowCPModal(cpData);
        if (val === 'PAPERLESS_POPUP') {
          this.showPaperlessPopup = true;
        } else if (this.isCPModalToShow && val) {
          this.updateModalTitle(val);
          this.showValidateCustModal = true;
        }
      });
    this.cps.getModalTitle().subscribe((val) => {
      const cpData = this.getCPDataFromStorage();
      this.isCPModalToShow = this.isEligibleToShowCPModal(cpData);
      if (this.isCPModalToShow && val && this.isItHaveActiveContact) {
        this.updateModalTitle(val);
        this.showValidateCustModal = true;
      }
    });
  }
  updateModalTitle(title) {
    switch (title) {
      case 'ADDPOLICY':
        this.validateCustomerTitle = `Looks like you added another policy!`;
        break;
      case 'AUTOPAY':
        this.validateCustomerTitle = `We see you've made some updates to your account recently`;
        break;
      case 'PAPERLESS':
        this.validateCustomerTitle = `Looks like you're going paperless!`;
        break;
      case 'ADDRESS':
        this.validateCustomerTitle = `We've noticed you changed your address recently.`;
        break;
      case 'EXPIRES_30_DAYS':
        this.validateCustomerTitle = `Your renewal is right around the corner!`;
        break;
      case 'AFTER_5_MONTHS':
        this.validateCustomerTitle = `Have you updated your contact information lately?`;
        break;
      case 'NOT_LOGGEDIN_90_DAYS':
        this.validateCustomerTitle = `We haven't seen you in a while! Has anything changed?`;
        break;
      default:
        break;
    }
  }
  isPolicyEligibleForLoyaltyBanner(policy) {
    if (policy) {
      return (policy.policyType === 'AUTO' && policy.policySubType !== 'MAIP') ||
        (policy.policyType === 'HOME' && policy.policySubType !== 'FAIR') ||
        (policy.policynumber.policyNumber.length === 6 && policy.policyType === 'AUTO')
    }
    return false;
  }
  private isAtleastOnePolicyElgblForLoyaltyBanner(policyList: any[]) {
    let isLoyaltyBannerVisible = false;
    policyList?.forEach(policy => {
      if (!isLoyaltyBannerVisible) {
        isLoyaltyBannerVisible = this.isPolicyEligibleForLoyaltyBanner(policy);
      }
    });
    return isLoyaltyBannerVisible;
  }
  isItHaveMAGWPolicy(policyList) {
    this.showQuickLinks = policyList.some((policy) => policy?.policynumber?.policyNumber?.length === 10 &&
      policy?.jurisdiction?.state === 'MA');
  }

  isItApplicableForQuickLinks(policyList) {
    if (this.isAcmic) {
      this.showQuickLinks = true;
    } else {
      this.isItHaveMAGWPolicy(policyList);
    }
  }


  ngOnInit() {
    this.clientCredentialsService.getToken().subscribe((token) => {
      // token.access_token
      // const token = JSON.parse(accessToken);
      const user = JSON.parse(localStorage.getItem('currentUser'));
      user.access_token = token;
      localStorage.setItem('currentUser', JSON.stringify(user));

      this.isAcmic = this.isAcmicService.isACMIC();
      if (this.isAcmic) {
        this.customerBannerService.loadAllCustomerBanners([]);
      }
      this.userDetailsService.getUserDetailsByEmail().pipe(takeUntil(this.destroy$)).subscribe();
      let allPoliciesList;
      // this.getAppLinks();
      this.paperlessService.$snooze.subscribe((snooze) => {
        if (snooze) {
          this.showUnEnrollBanner = false;
        }
      });
      this.onDashboardUrl();
      // this.onShowBanner();
      this.paperlessService.$displayBanner.subscribe((toogle) => {
        this.showUnEnrollBanner = toogle;
      });
      this.customerBannerService
        .getCustomerBannerData()
        .subscribe((customerBannerData) => {
          if (customerBannerData) {
            this.customerBannerData = customerBannerData;
          }
        });
      this.showValidateCustomerModal();
      this.policyDataService.$policyDetails.subscribe((policyList) => {
        if (policyList && policyList.length) {
          this.companyService.hasGWPolicy = policyList.some(policy =>
          policy?.policynumber?.policyNumber?.length === 10 &&
          policy?.jurisdiction?.state === 'MA'
          );
          this.actionWidgetService.setCustomerWidgets(
          this.actionWidgetService.getDefaultWidgets()
          );
          this.policies = policyList;
          this.isItApplicableForQuickLinks(policyList);
          this.areNoPolicies = false;
          this.isItHaveActiveContact = policyList[0].displayPhone;
          allPoliciesList = policyList;
          if (!this.isAcmic) {
            this.showLoyaltyBannerOnRouteChange(this.router, allPoliciesList);
          }
          // this.getAppLinks();
      }
      });
      this.onIdleTimeout();
      if (
        !(
          this.router.url == '/my-insurance/payment/wallet' ||
          this.router.url == '/my-insurance/payment' ||
          this.router.url == '/my-insurance/reportClaim'
        )
      ) {
        this.policyDetailsService
          .getPolicyDetailsByEmail(this.storageService.getUserFromStorage())
          .subscribe(
            (data: any) => {

             if (data) {
                  data.forEach(policy => {
                    if (
                      policy?.policynumber?.policyNumber?.length === 10 &&
                      policy?.jurisdiction?.state === 'MA'
                    ) {
                      this.companyService.hasGWPolicy = true;
                    }

                    if (policy.policynumber?.policyNumber?.length === 6) {
                      this.companyService.isAs400Only = true;
                    } else if (policy.company.companyName == "TW") {
                      this.companyService.isTW = true;
                    } else if (policy.company.companyName == "ACIC") {
                      this.companyService.isAcicOnly = true;
                    } else if (!(policy.company.companyName == "TW" || policy.company.companyName == "ACIC")) {
                      this.companyService.isMa = true;
                    }
                  });
                   this.companyService.getCompany();
              }
              // this.loading = false;
              this.existMAPolicy = this.policyDataService.getPolicyList()?.some(policy =>
                policy.company?.companyName !== "ACIC" && policy.company?.companyName !== "TW")

            },
            (err) => {
              if (
                err &&
                err.error &&
                err.error.Message &&
                err.error.Message.toLowerCase() === 'no policy linked to account'
              ) {
                this.areNoPolicies = true;
                this.policyDataService.updatePolicyDetails([]);
                this.userDetailsService.setCustomActionWidget().subscribe();
                this.router.navigate([Constants.MY_INSURANCE, 'add-policy']);
              } else if (
                err &&
                err.error &&
                err.error.Message &&
                err.error.Message.toLowerCase() === 'no account found'
              ) {
                this.logoutService.logout();
                this.alertService.error('NO_POLICIES_FOR_GIVEN_EMAIL', false);
              } else {
                this.errorRedirectionService.redirect(err.status);
              }
            }
          );

        this.claimsService
          .getClaimsDetails(this.storageService.getUserFromStorage())
          .subscribe(
            (response) => {
              this.claimsDataService.updateClaims(response);
              // this.loading = false;
            },
            () => {
              this.claimsDataService.updateClaims(false);
            }
          );

        this.policyDataService.$expiringLivoPolicies.subscribe(
          (expiringPolicyList: any) => {
            if (expiringPolicyList && expiringPolicyList.length > 0) {
              this.expiringLivoPolicyList = expiringPolicyList;
              this.fetchExpiringLivoPolicyDocs(expiringPolicyList);
            }
          }
        );

        this.featureToggleService.getFeatureToggles().subscribe(
          (response: FlagResponse) => {
            // this.mobileMessage = response.mobile;
            this.leakbotToggle = response.lb;
            if (response) {
              this.flagDataService.updateflagDetails(response);
            }
          },
          () => {
            this.leakbotToggle = false;
            this.flagDataService.clear();
          }
        );

        if (this.router.url === Constants.MY_INSURANCE) {
          this.reportClaim = true;
          this.leakbot = true;
          this.showAlert = true;
          this.myInsurence = true;
        } else if (
          this.router.url === '/billing/paperless'
        ) {
          this.reportClaim = false;
          this.leakbot = false;
          this.showAlert = false;
          this.myInsurence = false;
        } else if (
          this.router.url === '/billing/autopay'
        ) {
          this.reportClaim = false;
          this.leakbot = false;
          this.showAlert = true;
          this.myInsurence = false;
        } else {
          this.reportClaim = false;
          this.leakbot = false;
          this.myInsurence = false;
        }

        this.router.events.subscribe((event) => {
          if (event instanceof NavigationEnd) {
            if (event.url === Constants.MY_INSURANCE) {
              this.reportClaim = true;
              this.leakbot = true;
              this.showAlert = true;
              this.myInsurence = true;

              this.onDashboardUrl();
            } else if (
              event.url === '/profile' ||
              // event.url === '/profile/manage-contact-details' ||
              event.url === '/billing/autopay' ||
              event.url.endsWith('/documents') ||
              event.url.endsWith('/upload-documents')
            ) {
              this.reportClaim = false;
              this.leakbot = false;
              this.showAlert = true;
              this.myInsurence = false;
              this.onDashboard = false;
            } else if(
              event.url === '/billing/paperless'
            ){
              this.reportClaim = false;
              this.leakbot = false;
              this.showAlert = false;
              this.myInsurence = false;
              this.onDashboard = false;
            }
            else {
              this.reportClaim = false;
              this.leakbot = false;
              this.showAlert = false;
              this.myInsurence = false;
              this.onDashboard = false;
            }
            if (!this.isAcmic) {
              this.showLoyaltyBannerOnRouteChange(event, allPoliciesList);
            }
          }
        });
      }
    })
  }
  showLoyaltyBannerOnRouteChange(eventOrRoute, allPoliciesList) {
    if (eventOrRoute?.url === Constants.MY_INSURANCE ||
      (eventOrRoute?.url === '/billing-new' || eventOrRoute.url === '/billing-new/billing-landing')) {
      this.showLoyaltyBanner = this.isAtleastOnePolicyElgblForLoyaltyBanner(allPoliciesList);
    } else if ((eventOrRoute?.url?.startsWith(Constants.MY_INSURANCE) && (eventOrRoute?.url?.endsWith('/details') || eventOrRoute?.url?.endsWith('/coverages')) ||
      (eventOrRoute?.url?.startsWith('/billing-new/')))) {
      const policyIdFromUrl = eventOrRoute.url.split('/')[2];
      const policyObj = allPoliciesList.find(policy => policyIdFromUrl === policy?.policynumber?.policyNumber);
      this.showLoyaltyBanner = this.isPolicyEligibleForLoyaltyBanner(policyObj);
    } else {
      this.showLoyaltyBanner = false;
    }
  }
  closeModal() {
    this.showValidateCustModal = false;
  }

  fetchExpiringLivoPolicyDocs(expiringLivoPolicies) {
    const documentObservablesList = [];
    expiringLivoPolicies.forEach((policy) => {
      documentObservablesList.push(
        this.policyDetailsService
          .getDocumentsByPolicy(policy.policynumber.policyNumber)
          .pipe(catchError(() => of(false)))
      );
    });
    forkJoin(documentObservablesList).subscribe((results) => {
      if (results) {
        results.forEach((result: any, i) => {
          result.policyNumber =
            expiringLivoPolicies[i].policynumber.policyNumber;
        });
        this.documentsDataService.updaterenewalPoliciesDocumentData(results);
      }
    });
  }

  lockScreenEvent(event) {
    this.lockScreen = event;
  }

  onLockScreenHide() {
    this.lockScreen = false;
  }
}
